/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';

export function jobsToggles() {
  $('.join__jobDescription').hide();
  $('.join__titleWrap').on('click tap', function () {
    $(this).toggleClass('active');
    $(this).parent().find('.join__jobDescription').slideToggle();
  });
}
